const inventorySet = (items, key) => new Set(items.map((item) => item[key]));

export function areStudioInventoriesReady({ cloudState, hydrated, tenantId }) {
    return hydrated && (
        !tenantId
        || (cloudState.tenantId === tenantId && cloudState.status === "ready")
    );
}

export function nextStudioTabState({
    activeIdx,
    canvases,
    inventoriesReady,
    kernels,
    tabs,
    triggers,
    workflows,
}) {
    if (!inventoriesReady) return null;

    const inventories = {
        kernel: inventorySet(kernels, "command"),
        canvas: inventorySet(canvases, "slug"),
        workflow: inventorySet(workflows, "command"),
        trigger: inventorySet(triggers, "command"),
    };
    const dropIndexes = [];
    for (let index = 0; index < tabs.length; index += 1) {
        const tab = tabs[index];
        const inventory = inventories[tab.kind];
        if (inventory && !inventory.has(tab.payload)) dropIndexes.push(index);
    }
    if (dropIndexes.length === 0) return null;

    const nextTabs = tabs.filter((_, index) => !dropIndexes.includes(index));
    let nextActiveIdx = activeIdx;
    for (const index of dropIndexes) {
        if (index < nextActiveIdx) nextActiveIdx -= 1;
        else if (index === nextActiveIdx) {
            nextActiveIdx = Math.min(nextActiveIdx, nextTabs.length - 1);
        }
    }
    return {
        tabs: nextTabs,
        activeIdx: Math.max(0, nextActiveIdx),
    };
}
